import { useState } from 'react';
import { Button, Modal, Rate, Space } from 'antd';

const RatingModal = ({ open, onClick, setOpen }) => {
  const [rating, setRating] = useState(0);
  return (
    <Modal centered open={open} footer={null} onCancel={() => setOpen()}>
      <h1>الرجاء اضافة تقييم للطلب السابق</h1>
      <Space direction='vertical'>
        <Rate onChange={(value) => setRating(value)} />
        <Button type='primary' onClick={() => console.log(rating)}>
          تقييم
        </Button>
      </Space>
    </Modal>
  );
};

export default RatingModal;
